import { Action } from '@/_core/fluxstore/types';
import { CurrentWsState } from '../types';
import { useCurrentWsStore } from '../useModule';

const { registerReducer } = useCurrentWsStore();

export class RemoveMember extends Action<CurrentWsState> {
    public static ACTION_TYPE = 'RemoveMember';
    public constructor(public role: number) {
        super(RemoveMember.ACTION_TYPE);
    }
}

const reducer = (state: CurrentWsState, action: RemoveMember): void => {
    if(action.role === 0) {
        state.observerCount -= 1;
    } else {
        state.memberCount -= 1;
    }
};

//@ts-ignore
registerReducer(RemoveMember.ACTION_TYPE, reducer);